import CharacterCount from "@tiptap/extension-character-count";
import type { Extensions } from "@tiptap/react";
import type { EditorProps } from "../types/editor";
import { UtilityExtension } from "./utility";
import { CustomMentionExtension } from "./mentions/extention";
import { CustomStarterKitExtension } from "./starter-kit";
import { CustomPlaceholderExtension } from "./placeholder";

type Arguments = Pick<
  EditorProps,
  "isTouchDevice" | "mentionHandler" | "placeholder"
> & {
  editable: boolean;
};

export const CoreEditorExtensions = (args: Arguments): Extensions => {
  const { isTouchDevice = false, mentionHandler, editable, placeholder } = args;

  const extensions: Extensions = [
    CustomStarterKitExtension(),
    ...(mentionHandler ? [CustomMentionExtension(mentionHandler)] : []),
    CustomPlaceholderExtension({ placeholder }),
    CharacterCount,
    UtilityExtension({ isEditable: editable, isTouchDevice })
  ];

  return extensions;
};
